import React from 'react'
import {FieldViewProps} from "../../../render/view";
import AttachmentsManager from "../../../../gd-components/files/attachments-manager/attachments-manager";
import AttachmentsCollection from "../../../../model2/attachment/attachments";
import {AttachFileMode} from "../../../../gd-components/files/const";


// const debug = "FieldAttachment_View"
const debug = false

export default function FieldAttachment_View(props:FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    const attachmentsCollection: AttachmentsCollection = value ?
        new AttachmentsCollection([value])              :
        new AttachmentsCollection([])

    if (!value) return null

    return (
        <AttachmentsManager mode                    =   {AttachFileMode.VIEW}
                            onlySingleFile          =   {true}
                            dropzoneDOMElementId    =   "ui-page"
                            className               =   "single-item w-100-percent"
                            attachmentsCollection   =   {attachmentsCollection}/>
    )

}
